import * as React from 'react'
import { useDrag } from '../../../lib/hooks/useDrag'
import { AnimatedCircle } from '../../../components/AnimatedCircle'
import { useDevice } from '../../../lib/hooks/useDevice'
import { DRAGGING_HANDLE_AXIS_RADIUS_MOBILE, CIRCLE_SHADOW_ID } from '../constants'

interface Props {
  className?: string
  cx: number
  cy: number
  radius?: number
  draggingRadius?: number
  color?: string
  onDrag: any // TODO: any
  onDragStart: any // TODO: any
  onDragEnd: any // TODO: any
  fillOpacity?: number
}

export const DraggableCircle: React.FC<Props> = ({
  className = '',
  cx,
  cy,
  radius = 5,
  draggingRadius = 10,
  color = 'white',
  onDrag,
  onDragStart,
  onDragEnd,
  fillOpacity = 0.5,
}) => {
  const [ref, isDragging] = useDrag(onDrag, onDragStart, onDragEnd)
  const [isMobile] = useDevice()

  return (
    <g
      className={`-draggable-circle pointer user-select-none ${className}`}
      ref={ref}
      transform={`translate(${cx}, ${cy})`}
    >
      {isMobile ? (
        <>
          <AnimatedCircle
            cx={0}
            cy={0}
            r={isDragging ? draggingRadius : radius}
            fill={color}
            fillOpacity={fillOpacity}
            filter={`url(#${CIRCLE_SHADOW_ID})`}
          />
          <circle cx={0} cy={0} r={DRAGGING_HANDLE_AXIS_RADIUS_MOBILE} fill="red" fillOpacity={0} />
        </>
      ) : (
        <AnimatedCircle
          cx={0}
          cy={0}
          r={isDragging ? draggingRadius : radius}
          fill={color}
          fillOpacity={fillOpacity}
          filter={`url(#${CIRCLE_SHADOW_ID})`}
        />
      )}
    </g>
  )
}
